import { bindServices } from '@/services/api';
import { getFiltersGlobalFilters, toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';
import { merge } from 'lodash';

const api = bindServices('delegatedTasks');
const { delegatedTasks } = CoreQueries;

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

/**
 * Child list — Pattern X: parent-scoped via `delegation/delegatedTasks/:delegationId`
 * or `…/:delegationId/:configurationId` (no `/paged` suffix).
 */
const Model = {
  namespace: 'delegatedTasks',

  state: {
    list: [],
    orderBy: 'created desc',
    pagination: { ...meta },
    searchTable: '',
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const { readPriority, route, page, limit, search, orderBy, filter, ...rest } =
          payload || {};
        if (!route) return;

        const response = yield call(api.getAll, {
          route,
          params: {
            page,
            limit,
            search,
            orderBy: orderBy || 'created desc',
            filter,
            ...delegatedTasks.paged,
            ...rest,
          },
          readPriority: readPriority ?? false,
        });
        yield put({
          type: 'queryList',
          payload: {
            ...response,
            page,
            limit,
            searchTable: search,
          },
        });
      } catch (error) {}
    },

    *setOrderBy({ payload }, { put }) {
      yield put({ type: 'orderBy', payload });
    },

    *hideAllForms(_, { put }) {
      yield put({ type: 'hideForms' });
    },
  },

  reducers: {
    queryList(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: merge(state.pagination, toPaginate(payload)),
        searchTable: payload.searchTable ? payload.searchTable : '',
      };
    },
    orderBy(state, { payload }) {
      return { ...state, orderBy: payload };
    },
    hideForms(state) {
      return { ...state, orderBy: 'created desc' };
    },
    setSearchTable(state, { payload }) {
      return { ...state, searchTable: payload ?? '' };
    },
    clearList(state) {
      return {
        ...state,
        list: [],
        pagination: { ...meta },
      };
    },
  },
};

export default Model;
